<template>
    <div v-if="hasRating && rating" class="rating" :aria-label="ariaLabel" role="region">
        <Icon
            v-for="star in Math.floor(rating)"
            :key="star"
            type="Star"
            size="xs"
            color="violet" />
        <Icon v-if="rating % 1 !== 0" type="HalfStar" size="xs" color="violet" />
    </div>
</template>

<script lang="ts">
    import { t } from '@shared/helpers/translation';
    import { computed, defineComponent, PropType } from 'vue';
    import Icon from '../Icon/Icon.vue';

    export default defineComponent({
        name: 'Rating',
        components: { Icon },
        props: {
            rating: {
                type: Number as PropType<number | null>,
                default: null,
            },
            max: { type: Number, default: 5 },
        },
        setup(props) {
            const hasRating = computed(
                () => props.rating !== null && props.rating > -1 && props.rating < 6
            );

            const ariaLabel = computed(() => {
                return t({
                    key: 'aria.x_out_of_x_rating',
                    values: [props.rating, props.max],
                });
            });

            return {
                hasRating,
                ariaLabel,
            };
        },
    });
</script>

<style lang="scss" scoped>
    @forward './Rating.scss';
</style>
